import { ProtectedRoute } from "@app/protected-route";
import { GroupScoringDetailPage } from "@pages/group-scoring-detail-page/group-scoring-detail-page";
import { createFileRoute } from "@tanstack/react-router";

interface SearchParamsGroupScoring {
	tab?: "ocr" | "scoring";
	applicationId?: string;
}

export const Route = createFileRoute(
	"/_layout/applications/group/$groupScoringId",
)({
	component: RouteComponent,
	validateSearch: (search: SearchParamsGroupScoring) => ({
		tab: search.tab || "scoring",
		applicationId: search.applicationId,
	}),
});

function RouteComponent() {
	return (
		<ProtectedRoute
			requiredPermissions={[
				"see_all_logs",
				"create_and_score_application",
				"read_results",
			]}
		>
			<GroupScoringDetailPage />
		</ProtectedRoute>
	);
}
